import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function CTASection() {
  const navigate = useNavigate();
  return <section className="bg-primary-500 py-20" data-id="element-786">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center" data-id="element-787">
        <h2 className="text-3xl sm:text-5xl font-black text-white mb-4" data-id="element-788">
          Ready to take control
          <br data-id="element-789" />
          of your finances?
        </h2>
        <p className="text-lg text-primary-200 mb-8 max-w-xl mx-auto" data-id="element-790">
          Join 100,000+ people who use Possible to make smarter money decisions
          every day.
        </p>
        <div className="flex flex-wrap gap-4 justify-center" data-id="element-791">
          <button onClick={() => navigate('/signup')} className="flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-black font-bold px-8 py-4 rounded-xl transition-all hover:scale-105 active:scale-95 shadow-lg text-lg" data-id="element-792">
            Start for free <ArrowRight size={18} data-id="element-793" />
          </button>
          <button onClick={() => navigate('/login')} className="flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white font-semibold px-8 py-4 rounded-xl border border-white/30 transition-colors text-lg" data-id="element-794">
            Sign in
          </button>
        </div>
        <p className="text-primary-300 text-sm mt-4" data-id="element-795">
          No credit card required · Free forever plan available
        </p>
      </div>
    </section>;
}